
import './App.css';
import Header from './Header';
import Sectwo from './Sectwo';
import Sectthree from './Sectthree';
import Secfour from './Secfour';
import Secfive from './Secfive';
import Footer from './Footer';



function App() {
  return (

    <>
      <section>
        <Header/>
        <Sectwo/>
        <Sectthree/>
        <Secfour/>
        <Secfive/>
        <Footer/>

      </section>
    </>



  );
}

export default App;
